// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"28880":"51ce930283c4921a","36982":"4d6b1e618289a039","47938":"06c9abed76868c3a","48846":"6438dbb375600f1b","64558":"3dd81c0e18a02d8d","68530":"5e9963699255a091","85160":"401f49fea547e2d4"}[chunkId] + ".css";
};